var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneResearchanddevelopment48 = function SvgAIconDualtoneResearchanddevelopment48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6645 7.52051H7.02051C6.19208 7.52051 5.52051 8.19208 5.52051 9.02051V30.8836C5.52051 31.7121 6.19208 32.3836 7.02051 32.3836H28.1233H35.6645C36.4929 32.3836 37.1645 31.7121 37.1645 30.8836V21.0822V9.02051C37.1645 8.19208 36.4929 7.52051 35.6645 7.52051Z",
    fill: "#DCECFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.954 33.3883V27.1097H35.6755V33.3883L30.0356 42.0653C29.5341 42.8369 29.4947 43.8211 29.9331 44.6303C30.3715 45.4395 31.2174 45.9441 32.1377 45.9454H45.4884C46.4094 45.9453 47.2564 45.4412 47.6956 44.6318C48.1348 43.8223 48.0958 42.8374 47.5939 42.0653L41.954 33.3883Z",
    fill: "#DCECFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4199 27.1097H43.2099",
    stroke: "#DCECFA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.644 16.5617V4.5C32.644 3.67157 31.9724 3 31.144 3H2.5C1.67157 3 1 3.67157 1 4.5V26.3631C1 27.1916 1.67157 27.8631 2.5 27.8631H23.6028",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52051 18.3082V21.0823",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.041 12.4509V21.0822",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5615 14.3014V21.0822",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.082 17.6919V21.0823",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6025 10.911V21.0823",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.123 13.548V18.0685",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3818 33.7871L17.7182 33.7871L13.0545 33.7871",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9775 28.6166V33.2802",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8994 22.5891H38.6894",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4335 28.8677V22.5891H31.155V28.8677L25.5151 37.5447C25.0136 38.3163 24.9742 39.3005 25.4126 40.1097C25.851 40.9189 26.6969 41.4235 27.6172 41.4248H40.9679C41.8889 41.4247 42.7359 40.9206 43.1751 40.1111C43.6143 39.3017 43.5753 38.3168 43.0734 37.5447L37.4335 28.8677Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.708 32.6348H39.8839",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1787 36.4019H38.6901",
    stroke: "#2C5A82",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 35.1464V37.6578",
    stroke: "#2C5A82",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8994 37.9717C30.0725 37.9721 30.2125 38.1126 30.2125 38.2856",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5859 38.2856C29.5859 38.1122 29.7265 37.9717 29.8999 37.9717",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8999 38.5995C29.7265 38.5995 29.5859 38.4589 29.5859 38.2855",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2133 38.2855C30.2133 38.4589 30.0728 38.5995 29.8994 38.5995",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4111 35.4601C32.5845 35.4601 32.7251 35.6006 32.7251 35.774",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0977 35.774C32.0977 35.6006 32.2382 35.4601 32.4116 35.4601",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4116 36.0881C32.2382 36.0881 32.0977 35.9475 32.0977 35.7742",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7241 35.7742C32.7241 35.9475 32.5835 36.0881 32.4102 36.0881",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4353 27.6121H34.9238",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDualtoneResearchanddevelopment48 as ReactComponent };
export default "data:image/svg+xml;base64,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";